// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-label + .radio {
  margin-top: 0;
}

.condensed.form-group {
  margin-bottom: 0;
}
.condensed.form-group .checkbox {
  margin-bottom: 3px;
  margin-top: 3px;
}

:host:last-child .condensed.form-group {
  margin-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/gamma/form/formquestion/bootstrap/radiobutton/radiobutton.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;AAAI;EACI,kBAAA;EACA,eAAA;AAER;;AAIQ;EACI,mBAAA;AADZ","sourcesContent":[".radio-label + .radio {\n    margin-top: 0;\n}\n\n.condensed.form-group {\n    margin-bottom: 0;\n    .checkbox {\n        margin-bottom: 3px;\n        margin-top: 3px;\n    }\n}\n\n:host {\n    &:last-child {\n        .condensed.form-group {\n            margin-bottom: 15px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
